import { initLoc as initSharedLoc, t as sharedT } from '../../../packages/src/localization/index.js';
import { normalizeLanguageSettings } from '../../../packages/src/localization/languageSettings.js';
import fallbackTranslations from '../../../packages/src/localization/translations/fallback.js';

let isLocalizationEnabled = false;

export async function initLoc() {
  const localizationContext = window.localizationContext;

  if (!localizationContext?.orgId || !localizationContext?.eventCode) {
    return false;
  }

  const languageSettings = normalizeLanguageSettings(localizationContext.languageSettings);
  const browserLanguage = window.navigator.language.split('-')[0];
  const initialLanguage = languageSettings.availableLanguages.includes(browserLanguage)
    ? browserLanguage
    : languageSettings.defaultLanguage;

  await initSharedLoc({
    orgId: localizationContext.orgId,
    eventCode: localizationContext.eventCode,
    projectName: 'webapp',
    languageSettings,
    initialLanguage,
    autoApplyDataLoc: true,
  });

  isLocalizationEnabled = true;
  return true;
}

export function t(key, options) {
  if (isLocalizationEnabled) {
    return sharedTranslate(key, options);
  }

  return getEnglishFallback(key, options);
}

function sharedTranslate(key, options) {
  return sharedT(key, options);
}

function getEnglishFallback(key, options = {}) {
  const translations = fallbackTranslations.webapp.en.common;

  if (translations[key] !== undefined) {
    return interpolate(translations[key], options);
  }

  if (options.count !== undefined) {
    const pluralKey = options.count === 1 ? `${key}_one` : `${key}_other`;
    if (translations[pluralKey] !== undefined) {
      return interpolate(translations[pluralKey], options);
    }
  }

  return key;
}

function interpolate(template, options) {
  return String(template).replace(/\{\{(\w+)\}\}/g, (_, key) => options[key] ?? '');
}
